import { render, staticRenderFns } from "./budgetPie.vue?vue&type=template&id=db29b044&scoped=true&"
import script from "./budgetPie.vue?vue&type=script&lang=js&"
export * from "./budgetPie.vue?vue&type=script&lang=js&"
import style0 from "./budgetPie.vue?vue&type=style&index=0&id=db29b044&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db29b044",
  null
  
)

export default component.exports